import CancelPolicyImage from '@/images/ui/cancellation-policy.svg';
import LuggagePolicyImage from '@/images/ui/luggage-policy.svg';
import PetPolicyImage from '@/images/ui/pet-policy.svg';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

function getImage(type) {
	let src = null;
	switch (type) {
		case 'cancellation_policy':
			src = CancelPolicyImage;
			break;
		case 'pet_policy':
			src = PetPolicyImage;
			break;
		case 'luggage_policy':
			src = LuggagePolicyImage;
			break;
	}
	return (
		src && (
			<Image
				alt={`${type} policy`}
				title={`${type} policy`}
				src={src}
				className="h-[25vh] max-w-full lg:h-auto lg:w-5/12"
			/>
		)
	);
}

export default function CompanyPolicy({ type, policy }) {
	const { t } = useTranslation('common');
	const policyTranslationKey = `policies.${type.replace('_policy', '')}`;

	return (
		<section id={type} className="overflow-hidden bg-white py-16">
			<div className="mx-auto max-w-7xl px-4 lg:px-8">
				<div className="relative mb-8">
					<div className="max-w-prose text-base lg:max-w-none">
						<h2 className="font-semibold leading-6 text-blue-600">
							{t(`${policyTranslationKey}.overtitle`)}
						</h2>
						<h3 className="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
							{t(`${policyTranslationKey}.title`)}
						</h3>
					</div>
				</div>
				<div className="relative">
					<svg
						className="absolute right-0 top-0 -mr-20 -mt-20 hidden md:block md:[overflow-anchor:none]"
						width={404}
						height={384}
						fill="none"
						viewBox="0 0 404 384"
						aria-hidden="true"
					>
						<defs>
							<pattern
								id="95e8f2de-6d30-4b7e-8159-f791729db21b"
								x={0}
								y={0}
								width={20}
								height={20}
								patternUnits="userSpaceOnUse"
							>
								<rect
									x={0}
									y={0}
									width={4}
									height={4}
									className="text-gray-200"
									fill="currentColor"
								/>
							</pattern>
						</defs>
						<rect
							width={404}
							height={384}
							fill="url(#95e8f2de-6d30-4b7e-8159-f791729db21b)"
						/>
					</svg>
					<svg
						className="absolute bottom-0 left-0 -mb-20 -ml-20 hidden md:block md:[overflow-anchor:none]"
						width={404}
						height={384}
						fill="none"
						viewBox="0 0 404 384"
						aria-hidden="true"
					>
						<defs>
							<pattern
								id="7a00fe67-0343-4a3c-8e81-c145097a3ce0"
								x={0}
								y={0}
								width={20}
								height={20}
								patternUnits="userSpaceOnUse"
							>
								<rect
									x={0}
									y={0}
									width={4}
									height={4}
									className="text-gray-200"
									fill="currentColor"
								/>
							</pattern>
						</defs>
						<rect
							width={404}
							height={384}
							fill="url(#7a00fe67-0343-4a3c-8e81-c145097a3ce0)"
						/>
					</svg>
					<div className="relative md:bg-white">
						<div className="lg:flex lg:flex-row-reverse lg:items-start lg:gap-6">
							{getImage(type)}
							<div
								className="prose"
								dangerouslySetInnerHTML={{ __html: policy }}
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
